import {
  hm5VersionListConstants,
  hm5VersionUploadConstants,
  hm5VersionDeleteConstants,
  hm5VersionConstants,
} from "../_redux-constants";

export function hm5VersionListReducer(
  state = {
    hm5VersionListLoading: false,
    hm5VersionListData: null,
    hm5VersionListError: null,

    hm5VersionUploadLoading: false,
    hm5VersionUploadData: null,
    hm5VersionUploadError: null,

    hm5VersionLoading: false,
    hm5VersionData: null,
    hm5VersionError: null,
  },
  action
) {
  switch (action.type) {
    case hm5VersionListConstants.HM5VERSION_LIST_LOADING:
      return Object.assign({}, state, {
        hm5VersionListLoading: true,
        hm5VersionListData: null,
        hm5VersionListError: null,
      });
    case hm5VersionListConstants.HM5VERSION_LIST_SUCCESS:
      return Object.assign({}, state, {
        hm5VersionListLoading: false,
        hm5VersionListData: action.data,
      });
    case hm5VersionListConstants.HM5VERSION_LIST_FAILURE:
      return Object.assign({}, state, {
        hm5VersionListLoading: false,
        hm5VersionListData: null,
        hm5VersionListError: action.error,
      });
    case hm5VersionUploadConstants.HM5VERSION_UPLOAD_LOADING:
      return Object.assign({}, state, {
        hm5VersionUploadLoading: true,
        hm5VersionUploadData: null,
        hm5VersionUploadError: null,
      });
    case hm5VersionUploadConstants.HM5VERSION_UPLOAD_SUCCESS:
      return Object.assign({}, state, {
        hm5VersionUploadLoading: false,
        hm5VersionUploadData: action.data,
      });
    case hm5VersionUploadConstants.HM5VERSION_UPLOAD_FAILURE:
      return Object.assign({}, state, {
        hm5VersionUploadLoading: false,
        hm5VersionUploadData: null,
        hm5VersionUploadError: action.error,
      });
    case hm5VersionConstants.HM5VERSION_LOADING:
      return Object.assign({}, state, {
        hm5VersionLoading: true,
        hm5VersionData: null,
        hm5VersionError: null,
      });
    case hm5VersionConstants.HM5VERSION_SUCCESS:
      return Object.assign({}, state, {
        hm5VersionLoading: false,
        hm5VersionData: action.data,
      });
    case hm5VersionConstants.HM5VERSION_FAILURE:
      return Object.assign({}, state, {
        hm5VersionLoading: false,
        hm5VersionData: null,
        hm5VersionError: action.error,
      });
    case hm5VersionDeleteConstants.HM5VERSION_DELETE_LOADING:
      return Object.assign({}, state, {
        hm5VersionDeleteLoading: true,
        hm5VersionDeleteData: null,
        hm5VersionDeleteError: null,
      });
    case hm5VersionDeleteConstants.HM5VERSION_DELETE_SUCCESS:
      return Object.assign({}, state, {
        hm5VersionDeleteLoading: false,
        hm5VersionDeleteData: action.data,
      });
    case hm5VersionDeleteConstants.HM5VERSION_DELETE_FAILURE:
      return Object.assign({}, state, {
        hm5VersionDeleteLoading: false,
        hm5VersionDeleteData: null,
        hm5VersionDeleteError: action.error,
      });
    default:
      return state;
  }
}
